import { StateCreator } from 'zustand';
import { TreatmentChange } from '../../models';

export interface EditTreatmentSlice {
  treatmentSuggestedChanges: TreatmentChange;
  setTreatmentSuggestedChanges: (treatmentSuggestedChanges: TreatmentChange) => void;
}

export const createEditTreatmentSlice: StateCreator<EditTreatmentSlice, [], [], EditTreatmentSlice> = (set) => ({
  treatmentSuggestedChanges: {},
  setTreatmentSuggestedChanges: (treatmentSuggestedChanges: TreatmentChange) =>
    set((_) => ({ treatmentSuggestedChanges }))
});
